import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const ContentPane = ({ children }: Props) => {
  return <div styleName="content-pane">{children}</div>;
};

export default ContentPane;
